import { ConfirmDialog } from '@/components/Dialog';
import { useTranslation } from 'react-i18next';

type DeleteFilterConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filterName: string;
  isLoading?: boolean;
};

export const DeleteFilterConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  filterName,
  isLoading = false,
}: DeleteFilterConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('フィルタの削除')}
      messages={[
        t('「{{filterName}}」を削除しますか？', { filterName }),
        t('この操作は取り消すことができません。'),
      ]}
      confirmText={isLoading ? t('削除中...') : t('削除')}
      isConfirmDisabled={isLoading}
      isConfirmLoading={isLoading}
      confirmColor="danger"
    />
  );
};
